import {
  getObjects,
  getObject,
  addObject,
  updateObject,
  deleteObject,
  getObjectsWithParams,
} from "./Api";

// Visits
export const listEmergencyVisits = async (params = {}, token = "") => {
  return await getObjectsWithParams("emergency-visits", params, token);
};

export const getEmergencyVisit = async (id, token = "") => {
  return await getObject("emergency-visits", id, token);
};

export const createEmergencyVisit = async (data, token = "") => {
  return await addObject("emergency-visits", data, token);
};

export const updateEmergencyVisit = async (id, data, token = "") => {
  return await updateObject("emergency-visits", data, id, token);
};

export const deleteEmergencyVisit = async (id, token = "") => {
  return await deleteObject("emergency-visits", id, token);
};

// Charges
export const addEmergencyCharge = async (visitId, data, token = "") => {
  return await addObject(`emergency-visits/${visitId}/add-charge`, data, token);
};

export const listEmergencyCharges = async (visitId, token = "") => {
  return await getObjectsWithParams(
    `emergency-charges`,
    { visit: visitId },
    token
  );
};

export const updateEmergencyCharge = async (id, data, token = "") => {
  return await updateObject("emergency-charges", data, id, token);
};

export const deleteEmergencyCharge = async (id, token = "") => {
  return await deleteObject("emergency-charges", id, token);
};
